module.exports = __webpack_public_path__ + "files/dde733ee4cc3f56f77d6d5db7ca0e5cb.svg";